// 打印模板
import React, { PureComponent } from 'react';
import { message, Menu, Dropdown } from 'antd';
import { PropTypes } from 'prop-types';
import { unionBy, uniq } from 'lodash';
import { getData } from '@util';
import { API_GET_PRINT_TMP_LIST_MERGE } from '@api';

class DropDownTmp extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      menuDownLoad: <Menu></Menu>, // 模板list
    };
  }

  getPrintData = () => {
    const { selectedRows, scenes } = this.props;
    return getData({
      api: API_GET_PRINT_TMP_LIST_MERGE,
      searchParams: {
        subCusCodes: uniq(selectedRows.map(it => it.subCustomerNumber)),
        relationTypes: '1',
        scenes,
      },
    });
  };

  handleVisibleChange = async flag => {
    try {
      const { selectedRows, onSelect } = this.props;
      const len = selectedRows.length;
      if (!len) {
        message.error('请勾选订单');
        this.setState({ visible: false });
        return;
      }
      let resData = {};
      resData = await this.getPrintData().catch(error => {
        console.log('error is', error);
      });

      if (!resData) {
        return;
      }

      const { result = [] } = resData;
      const uniqSelectArr = unionBy(selectedRows, 'subCustomerNumber');
      if (result && Array.isArray(result) && result.length == 0) {
        return (
          flag &&
          message.error(
            <span>
              {uniqSelectArr.map(it => `${it.subCustomerNumber} ${it.subCustomerName}；`)}
              没有可以打印的模版，请联系相应的技术人员进行模版配置。
            </span>,
          )
        );
      }
      const menuDownLoad = (
        <Menu onClick={onSelect}>
          {result &&
            result.length &&
            result.map(item => {
              const { id = '', name = '' } = item;
              return <Menu.Item key={id}>{name}</Menu.Item>;
            })}
        </Menu>
      );
      this.setState({ menuDownLoad, visible: flag });
    } catch (error) {
      console.log('error is', error);
    }
  };
  render() {
    return (
      <Dropdown
        disabled={this.props.disabled}
        trigger={['click']}
        overlay={this.state.menuDownLoad || []}
        placement="bottomRight"
        visible={this.state.visible}
        getPopupContainer={triggerNode => triggerNode.parentNode}
        onVisibleChange={this.handleVisibleChange}>
        {this.props.children}
      </Dropdown>
    );
  }
}
DropDownTmp.propTypes = {
  onSelect: PropTypes.func.isRequired, // 选择下拉选项的回调
};
export default DropDownTmp;
